import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getNotificationPlaceholders = () => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.ENGAGEMENT_CENTER.GET_NOTIFICATION_PLACEHOLDERS
  );
};

export default getNotificationPlaceholders;
